export default {
  dashboard: () => import("/app/src/layouts/dashboard.vue"),
  default: () => import("/app/src/layouts/default.vue")
}